// extracted by mini-css-extract-plugin
export default {"navbar":"Header_navbar__hqGyG","link":"Header_link__8I6sm","active":"Header_active__juGvO"};